<template>
	<v-dropdown :label="trigger_label" :full_label="label" :mobile_label="mobile_label" :has_value="model.length > 0">
		<fieldset>
			<legend class="screen-reader-text">
				{{ label }}
			</legend>

			<label v-for="option in options" :key="option.value" class="checkbox">
				<input v-model="model" type="checkbox" :value="option.value" @change="emit(`change`)" />

				<v-icon slug="check" />

				<span>{{ option.label }}</span>
			</label>
		</fieldset>
	</v-dropdown>
</template>

<style lang="scss" scoped>
@use '/sass/toolkit' as *;

fieldset {
	@include filter-option-list;
}
</style>

<script setup>
import { computed } from 'vue';

import VDropdown from './_v-dropdown.vue';
import VIcon from './_v-icon.vue';

const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	mobile_label: {
		type: String,
		required: false,
		default: null,
	},
	options: {
		type: Array,
		required: true,
	},
});

const emit = defineEmits([`change`]);

const model = defineModel({
	type: Array,
	default: () => [],
});

const trigger_label = computed(() => {
	const checked = props.options.filter((option) => model.value.indexOf(option.value) > -1);

	if (checked.length === 0) {
		return props.label;
	}

	if (checked.length === 1) {
		return checked[0].label;
	}

	return `${checked[0].label} (+${checked.length - 1})`;
});
</script>
